import { IoClose } from "react-icons/io5";
import CuInput from "../../all-patient/components/CuInput";
import CuSuggestionBox from "../../common_component/component/CuSuggestionBox";
import { useEffect, useRef, useState } from "react";
import {
  useItemsFilter,
  useItemsFilterNew,
} from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { useAtom } from "jotai";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import BatchSuggestionList from "./BatchSuggestionList";
import { toast } from "react-toastify";

const SubLine = ({
  subLine,
  subIdx,
  handleSubLineChange,
  idx,
  // handleSelectMedicine,
  isView,
  handleSelectSubLineUom,
  lineLevelDisc,
  deleteSubLine,
  handleSelectBatch,
  handleSelectSubLine,
  // medicineStockLoading
}) => {
  const [searchInput, setSearchInput] = useState({
    subLine: "",
    mainLine: "",
    uom: "",
    batch_no: "",
  });
  const [clinic] = useAtom(clinicAtom);
  const [isBatchSuggestion, setIsBatchSuggestion] = useState(false);
  // const [filteredBatch, setFilteredBatch] = useState([]);
  // const [toastId, setToastId] = useState(null);
  const optionsContainerRef = useRef(null);

  const { data: medicines, isLoading: medicineLoading } = useItemsFilter(
    `master_data/medicine_with_batch/`,
    `?clinic_id=${clinic?.id}&name=${searchInput?.subLine}`,
    searchInput?.subLine?.length > 0 ? true : false,
    "",
    0
  );

  const { data: unitData, isLoading: uomLoading } = useItemsFilterNew(
    ApiEndPoint.CLINIC,
    `?action=getUnitsOfMeasure&clinic_id=${clinic?.id}&backend=True&name=${searchInput?.uom}`,
    clinic?.id && searchInput?.uom?.length > 0 ? true : false,
    (res) => res?.data
  );

  // const getBatchSuggestions = (response) => {
  //   setFilteredBatch(response.data);
  //   return response.data;
  // };

  // const { data: batchData, isLoading: batchLoading } = useItemsFilterNew(
  //   ApiEndPoint.INVENTORY,
  //   `?action=getBatchMaster&backend=True&clinic_id=${clinic?.id}&medicine_id=${subLine?.medicine_id}&is_consumed=True`,
  //   clinic?.id && subLine?.medicine_id ? true : false,
  //   getBatchSuggestions,
  //   0
  // );

  // useEffect(() => {
  //   if (batchLoading) {
  //     const id = toast.loading("Wait we are loading batch");
  //     setToastId(id);
  //   } else {
  //     toast.update(toastId, {
  //       render: "Batch loaded successfully!",
  //       type: "success",
  //       isLoading: false,
  //       autoClose: 3000,
  //     });
  //   }
  // }, [batchLoading]);

  const handleSearch = (value, label) => {
    if (label === "batch_no") {
      // const filteredData = batchData?.filter((ele) => {
      //   const batchNo = ele?.batch_number?.toLowerCase();
      //   return batchNo?.includes(value?.toLowerCase());
      // });
      // setFilteredBatch(filteredData || []);
      // if (value?.length > 0 && !isBatchSuggestion) {
      //   setIsBatchSuggestion(true);
      // }
    }
    setSearchInput({
      subLine: "",
      mainLine: "",
      uom: "",
      batch_no: "",
      [label]: value,
    });
  };

  const clearInput = () => {
    setSearchInput({ subLine: "", mainLine: "", uom: "", batch_no: "" });
  };

  const handleSelectDesc = (val, subIdx, idx) => {
    let extracted;
    if (val?.medicine_stock?.length > 0) {
      extracted = {
        id: val?.id || null,
        medicine_name: val?.medicine_name || "",
        generic_name: val?.generic_name?.name || "",
        price: val?.medicine_stock[0]?.price || 0,
        uom: val?.medicine_stock[0]?.uom || "",
        medicine_stock: JSON.parse(JSON.stringify(val?.medicine_stock)),
      };
    } else {
      extracted = {
        id: null,
        medicine_name: "",
        generic_name: "",
        price: 0,
        uom: "",
      };
      toast.error("This medicine is out of stock");
    }
    handleSelectSubLine(extracted, subIdx, idx);
    clearInput();
  };

  const handleSelectUom = (val, subIdx, idx) => {
    handleSelectSubLineUom(val, subIdx, idx);
    clearInput();
  };

  const getCheckedBatches = (batchId) => {
    const existingIdx = subLine?.batch_no?.findIndex(
      (ele) => ele?.batchId === batchId
    );
    if (existingIdx > -1) {
      return true;
    } else {
      return false;
    }
  };

  const handleBatchInputClick = () => {
    // if (searchInput?.batch_no?.length === 0) {
    setIsBatchSuggestion((prev) => !prev);
    // }
  };

  let batchNos = "";
  subLine?.batch_no?.forEach((ele) => {
    // if (Number(ele?.consumed_qty) > 0) {
    batchNos += `${ele?.batchNo}, `;
    // }
  });

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        optionsContainerRef.current &&
        !optionsContainerRef.current.contains(event.target)
      ) {
        setIsBatchSuggestion(false);
      }
    };

    if (isBatchSuggestion) {
      document.addEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [isBatchSuggestion]);

  return (
    <div className="cu-invoice-subline-cont">
      <div>
        <CuSuggestionBox
          options={medicines}
          label="Medicine Name"
          renderKey={"medicine_name"}
          searchInput={searchInput?.subLine}
          loading={medicineLoading}
          position={"calc(50% + 3px)"}
          searchable
          setSearchInput={(val) => handleSearch(val, "subLine")}
          onChange={(val) =>
            handleSubLineChange(val, "medicine_name", subIdx, idx)
          }
          handleSelectOption={(val) => handleSelectDesc(val, subIdx, idx)}
          value={subLine?.medicine_name}
          disabled={isView}
        />
      </div>
      <div>
        <CuInput
          type={"number"}
          placeholder={"select"}
          label="Quantity"
          value={subLine?.quantity}
          onChange={(e) =>
            handleSubLineChange(e.target.value, "quantity", subIdx, idx)
          }
          disabled={isView || !subLine?.medicine_id}
        />
      </div>
      <div>
        <CuInput
          type="text"
          label="Batch No"
          onChange={(e) => {
            handleSearch(e.target.value, "batch_no");
          }}
          onClick={handleBatchInputClick}
          value={batchNos}
          // loading={batchLoading}
          position="calc(50% - -3px)"
          disabled={isView || !subLine?.medicine_id}
        />
        {isBatchSuggestion && subLine?.medicine_stock?.length > 0 && (
          <div
            className="flex flex-col absolute border rounded z-[5] bg-[#FFFFFF]"
            ref={optionsContainerRef}
          >
            {subLine?.medicine_stock?.map((batch) => (
              <BatchSuggestionList
                key={batch?.batch_id}
                batch={batch}
                handleSelectBatch={handleSelectBatch}
                getCheckedBatches={getCheckedBatches}
                subIdx={subIdx}
                idx={idx}
              />
            ))}
          </div>
        )}
      </div>
      <div>
        <CuSuggestionBox
          options={unitData}
          label={"UOM"}
          renderKey={"name"}
          loading={uomLoading}
          position="calc(50% - -2px)"
          searchInput={searchInput?.uom}
          searchable
          setSearchInput={(val) => handleSearch(val, "uom")}
          onChange={(val) => handleSubLineChange(val, "uom", subIdx, idx)}
          handleSelectOption={(val) => handleSelectUom(val, subIdx, idx)}
          value={subLine?.uom}
          disabled={isView || !subLine?.medicine_id}
        />
      </div>
      <div>
        <CuInput
          type={"number"}
          label="Price"
          placeholder={"select"}
          value={subLine?.price}
          disabled={isView || !subLine?.medicine_id}
          onChange={(e) =>
            handleSubLineChange(e.target.value, "price", subIdx, idx)
          }
        />
      </div>
      <div>
        <div className="cu-invoice-line-discount-label">
          <label>Discount</label>
          <input
            type="checkbox"
            disabled={!lineLevelDisc}
            checked={subLine?.discount_type === "amount" ? false : true}
            onChange={() => {}}
            onClick={(e) =>
              handleSubLineChange(
                subLine?.discount_type === "amount" ? "percentage" : "amount",
                "discount_type",
                subIdx,
                idx
              )
            }
          />
        </div>
        <CuInput
          type={"number"}
          placeholder={"select"}
          disabled={!lineLevelDisc}
          value={subLine?.discount}
          onChange={(e) =>
            handleSubLineChange(e.target.value, "discount", subIdx, idx)
          }
        />
      </div>
      <div className="cu-invoice-line-INR-field">
        <label>INR</label>
        <div className="cu-invoice-line-INR text-[26px]">{subLine?.total}</div>
      </div>
      <div className="cu-invoice-line-icons">
        <IoClose
          size={20}
          className="cursor-pointer"
          onClick={() => deleteSubLine(idx, subLine?.id)}
        />
      </div>
    </div>
  );
};

export default SubLine;
